import React, {Component} from 'react';
import StackTeamsExposure from './stack-teams-exposure';
import BattingOrder from './batting-order';
import StackTeams from './stack-teams';
import StackTeamsChecking from './stack-teams-checking';
import TotalMinExposure from './total-min-exposure';
import MirrorStack from './mirror-stack';

class StackOptions extends Component {
    render() {
        const {stackNumber} = this.props;

        return (
            <div key={stackNumber} className="team-stack mlb-stack mw-half">
                <h3>STACK {stackNumber}</h3>
                <div className="form-row-new">
                    {/*<div className="form-sub-text">*/}
                    {/*    <strong>Stack</strong>*/}
                    {/*    <PlayersQuantity stackNumber={stackNumber} />*/}
                    {/*    <strong>players</strong>*/}
                    {/*</div>*/}
                    <div className="form-inline">
                        <strong className="form-text">Team exposures:</strong>
                        <StackTeamsExposure stackNumber={stackNumber} />
                    </div>
                    <TotalMinExposure stackNumber={stackNumber} />
                </div>
                <div className="chk-all-stack">
                    {stackNumber === 2 ? (
                        <MirrorStack sourceStackNumber={stackNumber - 1} destinationStackNumber={stackNumber} />
                    ) : null}
                    <div className="checkbox">
                        <StackTeamsChecking stackNumber={stackNumber} />
                    </div>
                    {stackNumber === 1 ? (
                        <MirrorStack sourceStackNumber={stackNumber + 1} destinationStackNumber={stackNumber} />
                    ) : null}
                </div>
                <div className="stack-container">
                    <StackTeams stackNumber={stackNumber} />
                </div>
                <BattingOrder stackNumber={stackNumber} />
            </div>
        );
    }
}

export default StackOptions;
